import type { AppConfig, OtherServicesURLs } from './AppConfig.d.ts';

export function getConfig(): AppConfig {
  return window.sgmeConfiguration;
}

export function getOtherServicesURL(
  entity: keyof AppConfig['otherServicesURLs'],
  service: keyof OtherServicesURLs,
): string {
  return window?.sgmeConfiguration?.otherServicesURLs?.[entity]?.[service] ?? '';
}
